import types from '@/store/types/CorreoAlternativo'
import Vue from 'vue';

const state = {
 
}
const getters = {
  
}
const mutations = {
   
}
const actions = {
    
    [types.actions.RegistrarCorreoA]:({commit},pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.post(`pajel/correo_alternativo/add`,pObj).then(r=>{
                resolve(r);
            })
        })
    },
    [types.actions.ActualizarCorreoA]:({commit}, pObj)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.put(`pajel/correo_alternativo/update`,pObj).then(r =>{
                resolve(r);
            }) 
        })
    },
    [types.actions.EliminarCorreoA]:({commit},pCorreoAlternativoId)=>{
        return new Promise((resolve,reject)=>{
            Vue.prototype.$http.delete(`pajel/correo_alternativo/delete/${pCorreoAlternativoId}`).then(r=>{
                resolve(r);
            })
        })
    },
    [types.actions.ListarCorreoA]:({commit},pUsuarioEmpresaId)=>{
        return new Promise ((resolve,reject)=>{
            Vue.prototype.$http.get(`pajel/correo_alternativo/list/${pUsuarioEmpresaId}`)
            .then(response=>{
                resolve(response);
            })
        })
    },
}
export default {
    state,
    actions,
    getters,
    mutations
}